export const APP_ID = 'TAMWEEL';

export const USER = `@@${APP_ID}_USER`;

export const DEVICE_ID = `@@${APP_ID}_USER_DEVICE_ID`;
